import React from 'react';
import { CopimCoursesWorkspacePage } from './CopimCoursesWorkspacePage';

export const CopimAssociationCoursesPage = () => <CopimCoursesWorkspacePage />;
